import {PublicContent} from './PublicContent';
export default PublicContent;
